import {AfterContentInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {combineLatest, Observable, of, Subscription}               from 'rxjs';
import {ApElementOxydTypeEnum, MapViewCurrentMenu, MapViewMode}    from '../../ap-interface';
import {
  ApDynComponentComponent
}                                                                  from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  ApDynGridColumnConfigBase
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridPagerConfigBase
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {
  AreaUnit,
  AreaUnitConverterPipe,
  GetRoundNumericPipe,
  GetSoilSampleClassNamePipe,
  GetSoilSampleFieldClassColorPipe
}                                                                  from '../../ap-utils';
import {
  ApDynGridPropertyColumnConfig,
  FilterType
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  ApDynGridGroupColumnConfig
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-group-column-config';
import {
  ApDynGridClassColorColumnConfig
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-class-color-column-config';
import {
  ApDynGridPagerConfig
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-pager-config';
import {SettingsStore}                                             from '../../stores/base-data/settings.store';
import {FieldStore}                                                from '../../stores/farm/field.store';
import {
  FieldNutrientDistributionStore
}                                                                  from '../../stores/nutrients/field-nutrient-distributions.store';
import {MapViewStore}                                              from '../../stores/layout/mapview.store';
import {MapStore}                                                  from '../../stores/map/map.store';
import {filter, map}                                               from 'rxjs/operators';
import {
  ApNutrientPlanningComponent
}                                                                  from '../../entry-components/ap-nutrients-management-entry-components/ap-nutrient-planning.component';
import {FormStore}                                                 from '../../stores/layout/form.store';
import {
  ApDynGridStatusColumnConfig
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {ApSoilSampleService}                                       from '../service/ap-soil-sample.service';
import {
  GetRoundNumericService
}                                                                  from '../../ap-utils/service/get-round-numeric.service';
import {
  ApFieldFormatService
}                                                                  from '../../ap-utils/service/ap-field-format.service';
import {ApDateService}                                             from '../../ap-core/services/ap-date-service';
import {LanguageStore}                                             from '../../stores/translation/language.store';
import {StatisticStore}                                            from '../../stores/statistic/statistic.store';
import {Create}                                                    from 'ts-tooling';
import {
  IImageStyle
}                                                                  from '../../ap-utils/service/get-soil-sample-class-color.service';
import {JobsStore}                                                 from '../../stores/administration/jobs.store';
import {
  GetElementService
}                                                                  from '../../ap-utils/service/ap-get-element.service';
import {ApNutrientService}                                         from '../../ap-utils/service/ap-nutrient.service';
import {APP_CONFIGURATION}                                         from '../../ap-core/config';
import {
  ApElementType
}                                                                  from '../../ap-interface/enums/ap-elements-type.enum';
import {CampaignYearStore} from '../../stores/login/campaignyear.store';
import {ApIcons}           from '../../ap-interface/enums/layout/ap-icons';
import {ApUtilService}     from '../../ap-utils/service/ap-util.service';
import {LoginStore}                                                from '../../stores/login/login.store';
import {
  ApTranslationService
}                                                                  from '../../ap-utils/service/ap-translation.service';
import {
  IApFieldNutrientDistributionGrid
}                                                                  from '../types/bese-fertilization-distribution.types';
import {
  PlanningEntryComponentDataType
}                                                                  from '../../entry-components/ap-nutrients-management-entry-components/ap-nutrient-planning-configs/nutrient-planning-types';
import {
  FieldStatisticHistogramService,
  IFieldStatisticHistogramData
}                                                                  from '../../services/data/field-statistic-histogram.service';
import {StatisticService}                                          from '../../services/data/statistic.service';
import {
  SoilSampleDateStore
}                                                                  from '../../stores/nutrients/soilsampledate.store';
import IField = Data.FieldManagement.IField;
import ISettings = Data.BaseData.ISettings;

@Component({
  selector: 'ap-nutrients-distribution',
  template: `
    <ap-dyncomponent [caption]="'Global__NutrientDistribution'"
                     [canCreate]="true"
                     [canSearch]="true"
                     [headerIcon]="'ap-icon-base-fertilization'"
                     [filterTooltip]="'filterTooltip'"
                     [columns]="columns"
                     [items]="items$ | async"
                     [loading$]="listenFieldNutrientDistributionsLoading$"
                     [pager]="pager"
                     [groupable]="true"
                     [selectable]="{checkboxOnly: false, mode: 'multiple'}"
                     (create)="onCreate()"
    ></ap-dyncomponent>
  `,
  styles: []
})
export class ApNutrientDistributionComponent implements OnInit, AfterContentInit, OnDestroy {
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;
  public columns: ApDynGridColumnConfigBase[] = [];
  public items$: Observable<any[]> = of([]);
  public pager: ApDynGridPagerConfigBase;
  public listenFieldNutrientDistributionsLoading$: Observable<boolean> = of(true);

  private _subscriptions: Subscription[] = [];
  private _settings: ISettings;
  private _currentFieldGeomIds: string[] = [];
  private _onSelectionChanged: Subscription;
  private _classColorColumnWidth = 45;
  private _valueColumnWidth = 45;

  constructor(private nutrientDistributionStore: FieldNutrientDistributionStore,
              private loginStore: LoginStore,
              private formStore: FormStore,
              private fieldStore: FieldStore,
              private mapStore: MapStore,
              private mapViewStore: MapViewStore,
              private roundNumericService: GetRoundNumericService,
              private roundNumericPipe: GetRoundNumericPipe,
              private nutrientService: ApNutrientService,
              private areaUnitPipe: AreaUnitConverterPipe,
              private settingsStore: SettingsStore,
              private soilSampleFieldClassColorPipe: GetSoilSampleFieldClassColorPipe,
              private soilSampleClassNamePipe: GetSoilSampleClassNamePipe,
              private translationService: ApTranslationService,
              private soilSampleService: ApSoilSampleService,
              private fieldFormatService: ApFieldFormatService,
              private languageStore: LanguageStore,
              private dateService: ApDateService,
              private statisticStore: StatisticStore,
              private fieldStatisticHistogramService: FieldStatisticHistogramService,
              private jobsStore: JobsStore,
              private soilSampleDateStore: SoilSampleDateStore,
              private campaignYearStore: CampaignYearStore,
              private statisticService: StatisticService,
              private elementService: GetElementService) {
  }

  public ngOnInit(): void {
    this.listenFieldNutrientDistributionsLoading$ = combineLatest([
      this.nutrientDistributionStore.Loading$,
      this.fieldStore.Listen(s => s.loading)
    ]).pipe(
      map(loadingItems => loadingItems.some(x => x))
    );
    this._mapDistributionsToGrid();
  }

  public ngAfterContentInit(): void {
    this._onSelectionChanged = this.dynComponent.SelectedItems$.subscribe(d => this._selectionChange(d));
    if (this.mapViewStore.getMapViewMode() !== MapViewMode.NORMAL) {
      this.mapViewStore.showMapView();
    }
    // disable drawing the crop colors and the selected style
    this.mapStore.EnableDistributionView();
    this._subscriptions.push(this.settingsStore.FirstSetting$.subscribe(s => this._settings = s));
    this._subscriptions.push(combineLatest([
        this.campaignYearStore.Listen(s => s.selectedYear),
        this.fieldStore.Listen(f => f.data)
      ]).pipe(
        filter(([campaignYear, fields]) => campaignYear && fields && fields?.length > 0))
        .subscribe(([_, fields]) => {
          this._readFieldGeomsOfCurrentLoadedFields(fields);
          this.nutrientDistributionStore.loadFieldNutrientDistributions(this._currentFieldGeomIds);
        })
    );
    this._gridBuilder();
    this._subscriptions.push(this.mapViewStore.Listen(d => d.currentMenu).subscribe(mapViewMenu => {
      if (mapViewMenu === MapViewCurrentMenu.STATS) {
        this._selectionChange(this.dynComponent.getSelectedItems() as IApFieldNutrientDistributionGrid[]);
      }
    }));
  }

  public ngOnDestroy(): void {
    this.statisticStore.removeStatisticData();
    // enable drawing the crop colors and the selected style
    this.mapStore.DisableDistributionView();
    this._subscriptions.forEach(d => d.unsubscribe());
    this._onSelectionChanged?.unsubscribe();
  }

  public onCreate(): void {
    this.formStore.openForm({
      component: ApNutrientPlanningComponent,
      data: {
        Summary: null,
        Type: PlanningEntryComponentDataType.Create
      }
    });
  }

  private _gridBuilder(): void {
    this.columns = [
      new ApDynGridStatusColumnConfig({
        field: 'Status',
        class: 'StatusClass',
        description: 'StatusDesc',
        showHeaderTitle: false,
        filterable: true,
        pending: this.jobsStore.BlockedFieldIdsBuWsv$,
        pendingTooltip: this.jobsStore.BlockedFieldIdsBuWsvTooltip$
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'FieldNumber',
        title: 'Global__NumberAbbr',
        filterable: true,
        width: 75,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'Field.FieldName',
        title: 'Global__FieldName',
        filterable: true,
        width: 180,
        headerFilterable: true,
        cssClass: 'left',
        sortIndex: 0
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'Area',
        title: 'Global__Area',
        filterable: true,
        width: 60,
        cssClass: 'right', filterType: FilterType.NUMBER,
        headerFilterable: true,
        pipes: [{
          pipe: this.roundNumericPipe,
          args: [
            this._settings.DigitsAfterDecimalPoint
          ]
        }]
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'SoilGroup',
        title: 'Nutrients__Soilgroup',
        width: 80,
        hide: true,
        filterable: true,
        filterType: FilterType.NUMBER_LIST,
        headerFilterable: true
      }),
      new ApDynGridGroupColumnConfig({
        headerStyle: {
          'text-align': 'center'
        },
        style: {border: '1px solid #2c3237'},
        title: 'Global__Avg_Class',
        groupColumns: [
          new ApDynGridClassColorColumnConfig({
            field: 'StyleClassP',
            title: this.elementService.GetElementStringByString(ApElementType.P),
            key: 'ClassP',
            width: this._classColorColumnWidth,
            filterable: true,
            tooltip: 'PValueTooltip',
            cssClass: 'center'
          }),
          new ApDynGridClassColorColumnConfig({
            field: 'StyleClassK',
            title: this.elementService.GetElementStringByString(ApElementType.K),
            key: 'ClassK',
            width: this._classColorColumnWidth,
            filterable: true,
            tooltip: 'KValueTooltip',
            cssClass: 'center'
          }),
          new ApDynGridClassColorColumnConfig({
            field: 'StyleClassMg',
            title: this.elementService.GetElementStringByString(ApElementType.Mg),
            key: 'ClassMg',
            width: this._classColorColumnWidth,
            filterable: true,
            tooltip: 'MgValueTooltip',
            cssClass: 'center'
          }),
          new ApDynGridClassColorColumnConfig({
            field: 'StyleClassPh',
            title: 'Nutrients__Ph',
            key: 'ClassPh',
            width: this._classColorColumnWidth,
            filterable: true,
            tooltip: 'PhValueTooltip',
            cssClass: 'center'
          })
        ]
      }),
      new ApDynGridGroupColumnConfig({
        headerStyle: {
          'text-align': 'center'
        },
        style: {border: '1px solid #2c3237'},
        title: 'Global__Avg_Content',
        hide: true,
        groupColumns: [
          new ApDynGridPropertyColumnConfig({
            field: 'PValue',
            title: this.elementService.GetElementStringByString(ApElementType.P),
            width: this._valueColumnWidth,
            hide: true,
            formatCallback: (dataItem, value) => `${(dataItem?.PIsGreaterE ? '> ' : '')}${value}`,
            filterable: true,
            cssClass: 'right', filterType: FilterType.NUMBER,
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [
                APP_CONFIGURATION.SpecialDecimalPlaces.Distributions
              ]
            }]
          }),
          new ApDynGridPropertyColumnConfig({
            field: 'KValue',
            title: this.elementService.GetElementStringByString(ApElementType.K),
            width: this._valueColumnWidth,
            hide: true,
            formatCallback: (dataItem, value) => `${(dataItem?.KIsGreaterE ? '> ' : '')}${value}`,
            filterable: true,
            cssClass: 'right',
            filterType: FilterType.NUMBER,
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [
                APP_CONFIGURATION.SpecialDecimalPlaces.Distributions
              ]
            }]
          }),
          new ApDynGridPropertyColumnConfig({
            field: 'MgValue',
            title: this.elementService.GetElementStringByString(ApElementType.Mg),
            width: this._valueColumnWidth,
            hide: true,
            formatCallback: (dataItem, value) => `${(dataItem?.MgIsGreaterE ? '> ' : '')}${value}`,
            filterable: true,
            cssClass: 'right',
            filterType: FilterType.NUMBER,
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [
                APP_CONFIGURATION.SpecialDecimalPlaces.Distributions
              ]
            }]
          }),
          new ApDynGridPropertyColumnConfig({
            field: 'PhValue',
            title: 'Nutrients__Ph',
            width: this._valueColumnWidth,
            hide: true,
            formatCallback: (dataItem, value) => `${(dataItem?.PhIsGreaterE ? '> ' : '')}${value}`,
            filterable: true,
            cssClass: 'right',
            filterType: FilterType.NUMBER,
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [
                APP_CONFIGURATION.SpecialDecimalPlaces.Distributions
              ]
            }]
          })
        ]
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Nutrients_Ips_Pages__LastBu',
        field: 'NewestSampleDate',
        format: this.languageStore.SelectedLanguage?.DateFormat,
        width: 80,
        hide: true,
        filterable: true,
        filterType: FilterType.MONTH
      })
    ];
    this.pager = new ApDynGridPagerConfig({
      iconButtons: [
        {
          icon: ApIcons.XLS,
          callback: ApUtilService.createEventEmitter(this.exportAsXls.bind(this), this._subscriptions),
          tooltip: 'Global__Save_EXCEL'
        }
      ]
    });
  }

  private _readFieldGeomsOfCurrentLoadedFields(fields: IField[]): void {
    const tmp = [];
    for (const field of fields) {
      if (!field.FieldGeoms || typeof field.FieldGeoms !== typeof [] || field.FieldGeoms.length < 1) {
        // skip Fields without Geometry
        continue;
      }
      for (const geom of field.FieldGeoms) {
        tmp.push(geom.Id);
      }
    }
    this._currentFieldGeomIds = tmp;
  }

  private _soilSampleClassName(value: number): string {
    return this.soilSampleClassNamePipe.transform(value);
  }

  private _soilClassColor(value: string): IImageStyle {
    return this.soilSampleFieldClassColorPipe.transform(value, [false]);
  }

  private _areaUnitConvert(value: number): any {
    return this.areaUnitPipe.transform(
      value, [AreaUnit.SQUARE_METER, AreaUnit.HEKTAR]);
  }

  private _selectionChange(items: IApFieldNutrientDistributionGrid[]): void {
    let itemsToSelect: IApFieldNutrientDistributionGrid[] = items;
    if (itemsToSelect && itemsToSelect.length > 0) {
      this.fieldStore.changeSelectedField(itemsToSelect.map(x => x.Id.toString()));
    } else {
      itemsToSelect = this.dynComponent.items as IApFieldNutrientDistributionGrid[];
      this.fieldStore.changeSelectedField([]);
      this.fieldStore.zoomFarmFields();
    }
    // calculate statistic only if user is on statistic tab
    if (this.mapViewStore.getMapViewCurrentMenu() !== MapViewCurrentMenu.STATS) {
      return;
    }
    setTimeout(() => {
      this.statisticStore.removeStatisticData();
      const statisticData = itemsToSelect.map(x => {
        const item: IFieldStatisticHistogramData = {
          Status: x.Status,
          FieldId: x.Field?.Id,
          FieldName: x.Field?.FieldName,
          AreaHa: x.FieldGeom?.AreaHa ?? 0,
          Histograms: x.SourceItem.Histograms
        };
        return item;
      });
      const title = this._getTitleForStatistic(itemsToSelect);
      this.fieldStatisticHistogramService.generateHistogramStatistic(title, statisticData);
    }, 0);
  }

  private _getTitleForStatistic(selectedItems: IApFieldNutrientDistributionGrid[]): string {
    const totalItems = this.dynComponent.items as IApFieldNutrientDistributionGrid[];
    const dataForTitles = totalItems.map(x => ({
      AreaHa: x.Area,
      Selected: selectedItems.some(z => z.Id === x.Id)
    }));
    return this.statisticService.generateFieldsAreaTitle(dataForTitles);
  }

  private exportAsXls(): void {
    const fileName = this._getExportFilename();
    const items = this.dynComponent.getSelectedItems() as IApFieldNutrientDistributionGrid[];
    const fieldGeometryIds = items.map(x => x.FieldGeom.Id);
    this.nutrientDistributionStore.statisticDataExcelExport(fileName, fieldGeometryIds);
  }

  private _getExportFilename(): string {
    const customerExpr = this.loginStore.SelectedFarm?.CustomerNumber;
    const dateExpr = this.dateService.toFarmDate(new Date()).format('YYMMDD');
    const componentName = this.translationService.translate('Global__NutrientDistribution');
    return `${dateExpr}_${componentName.replace(' ', '_')}_${customerExpr}`;
  }

  private _mapDistributionsToGrid(): void {
    this.items$ = combineLatest([
      this.nutrientDistributionStore.Distributions$,
      this.soilSampleDateStore.Dates$
    ]).pipe(
      filter(([dist, sampleDates]) => !!dist && !!sampleDates),
      map(([dist, sampleDates]) => {
        return dist.filter(x => x.SoilGroups?.length > 0).map((dis: any) => {
          const fieldGeom = this.fieldStore.getFieldGeomById(dis.FieldGeomId);
          const field = this.fieldStore.getFieldByFieldGeomId(dis.FieldGeomId);
          const adminArea = Create(fieldGeom?.AdminArea, 0);
          const areaNumber = adminArea > 0 ? adminArea : '-';
          let areaRound: string | number;
          if (areaNumber !== '-') {
            const area = this._areaUnitConvert(areaNumber);
            areaRound = this.roundNumericService.roundAsNumber(area, this._settings.DigitsAfterDecimalPoint);
          } else {
            areaRound = '-';
          }
          const newestSampleDate = this.dateService.getDateMidnight(sampleDates[field?.Id as string]?.Date);
          const classP = this._soilSampleClassName(dis.AvgClassP);
          const classK = this._soilSampleClassName(dis.AvgClassK);
          const classMG = this._soilSampleClassName(dis.AvgClassMg);
          const classPH = this._soilSampleClassName(dis.AvgClassPh);
          const pIsGreaterE = dis.AvgClassP > 8;
          const kIsGreaterE = dis.AvgClassK > 8;
          const mgIsGreaterE = dis.AvgClassMg > 8;
          const phIsGreaterE = dis.AvgClassPh > 8;
          const pValue = this.nutrientService.convertElementOxid(dis.AvgP, ApElementOxydTypeEnum.P, dis.MethodP);
          const kValue = this.nutrientService.convertElementOxid(dis.AvgK, ApElementOxydTypeEnum.K, dis.MethodK);
          const mgValue = this.nutrientService.convertElementOxid(dis.AvgMg, ApElementOxydTypeEnum.Mg, dis.MethodMg);
          const phValue = dis.AvgPh;
          const pValueRounded = this.roundNumericService.roundAsNumber(pValue, APP_CONFIGURATION.SpecialDecimalPlaces.Distributions);
          const kValueRounded = this.roundNumericService.roundAsNumber(kValue, APP_CONFIGURATION.SpecialDecimalPlaces.Distributions);
          const mgValueRounded = this.roundNumericService.roundAsNumber(mgValue, APP_CONFIGURATION.SpecialDecimalPlaces.Distributions);
          const phValueRounded = this.roundNumericService.roundAsNumber(phValue, APP_CONFIGURATION.SpecialDecimalPlaces.Distributions);
          const status = this.soilSampleService.getStatus(dis.NewestSampleDate);
          const soilGroups = [...dis.SoilGroups].Sort().join(', ');
          const translations = [
            'Nutrients_Ips_Pages__StatusRed',
            'Nutrients_Ips_Pages__StatusYellow',
            'Nutrients_Ips_Pages__StatusGreen',
          ];
          const classes = [
            'ap-status-red',
            'ap-status-yellow',
            'ap-status-green'
          ];
          return {
            Id: field?.Id,
            Status: status,
            StatusClass: classes[status + 1],
            StatusDesc: translations[status + 1],
            SoilGroup: soilGroups,
            SourceItem: dis,
            FieldNumber: this.fieldFormatService.formatFieldNumber(field),
            Field: field,
            FieldGeom: fieldGeom,
            Area: areaRound,
            ClassP: classP,
            ClassK: classK,
            ClassMg: classMG,
            ClassPh: classPH,
            StyleClassP: this._soilClassColor(classP),
            StyleClassK: this._soilClassColor(classK),
            StyleClassMg: this._soilClassColor(classMG),
            StyleClassPh: this._soilClassColor(classPH),
            PValue: pValueRounded,
            KValue: kValueRounded,
            MgValue: mgValueRounded,
            PhValue: phValueRounded,
            PIsGreaterE: pIsGreaterE,
            KIsGreaterE: kIsGreaterE,
            MgIsGreaterE: mgIsGreaterE,
            PhIsGreaterE: phIsGreaterE,
            PValueTooltip: this.nutrientService.formatClassificationTooltip(dis.AvgP, pIsGreaterE, dis.MethodP),
            KValueTooltip: this.nutrientService.formatClassificationTooltip(dis.AvgK, kIsGreaterE, dis.MethodK),
            MgValueTooltip: this.nutrientService.formatClassificationTooltip(dis.AvgMg, mgIsGreaterE, dis.MethodMg),
            PhValueTooltip: this.nutrientService.formatClassificationTooltip(dis.AvgPh, phIsGreaterE, dis.MethodPh),
            NewestSampleDate: newestSampleDate,
          } as IApFieldNutrientDistributionGrid;
        });
      })
    );
  }
}
